<template>
  <!-- <div class="flex flex-col border-b-2 border-gamma-blue">New HOW IT WORKS section 
    
  </div>END New HOW IT WORKS section -->
  <!-- <nav class="bg-white flex justify-center p-4 border-b-2 border-gamma-blue" v-if="!check_route">
    <div class="step-circle" v-for="(page, index) in pages" :key="index" @click="goToStep(index)">
      <div class="step-number" :class="{ 'active': $store.state.currentStep === index }">{{ index + 1 }}</div>
    </div>
  </nav> -->
  <div class="flex mx-auto items-center justify-center py-10 border-b-2 border-gamma-blue" v-if="!check_route">

    <button @click="goToPreviousPage()" :disabled="$store.state.currentStep == 0" class="">
      <img v-if="$store.state.currentStep == 0" src="@/assets/images/alg.svg" class="mr-5">
      <img v-else src="@/assets/images/alb.svg" class="mr-5">
    </button>

    <button @click="goToStep(index)" v-for="(page, index) in pages"
      class="flex items-center justify-center border-2 rounded-full w-10 h-10 mr-5"
      v-bind:class="[{ 'border-gamma-green bg-gamma-green': $store.state.currentStep == index }, { 'border-gamma-blue': $store.state.currentStep != index }]">
      <span class="font-bold text-xl mt-1"
        v-bind:class="[{ 'text-white': $store.state.currentStep == index }, { 'text-gamma-blue': $store.state.currentStep != index }]">
        {{ index + 1 }}
      </span>
    </button>

    <button @click="goToNextPage()" :disabled="$store.state.currentStep == 2" class="">
      <img v-if="$store.state.currentStep == 2" src="@/assets/images/arg.svg" class="">
      <img v-else src="@/assets/images/arb.svg" class="mr-5">
    </button>

  </div>
  <router-view />
  <FAQ v-if="!check_route" />
 
</template>
<script>
import './assets/tailwind.css'
import { mapState, mapMutations } from 'vuex'
import FAQ from './components/FAQ.vue'
export default {
  name: 'App',
  components: {
    FAQ
  },
  data() {
    return {
      currentColor : '#003878',
      pages: [
        {
          name: 'Home',
          title: 'Zo werkt het',
          image: './assets/images/gridWhite.png',
          route: '/gamma'
        },
        {
          name: 'Sizes',
          title: 'Opslagruimten',
          image: './assets/images/gridWhite.png',
          route: '/size'
        },
        {
          name: 'Offers',
          title: 'Jouw voorstel(len)',
          image: './assets/images/calculatorWhite.png',
          route: '/offers'
        },
        // {
        //   name: 'Details',
        //   title: 'Jouw gegevens',
        //   image: './assets/images/infoWhite.png',
        //   route: '/details'
        // },
        // {
        //   name: 'Offers',
        //   title: 'Jouw voorstel(len)',
        //   image: './assets/images/calculatorWhite.png',
        //   route: '/offers'
        // },
      ],
      check_route: false,
     
    }
  },
  computed: {
    ...mapState(['currentQuote', 'submitData', 'quotes', 'instantCalculation', 'popup']),

  },
  methods: {
    ...mapMutations(['changeSubmitData', 'completeStep', 'changePopup', 'changeCalculating', 'changeCurrentStep']),
    goToPreviousPage() {

      if (this.$store.state.currentStep > 0) {
        this.changeCurrentStep(this.$store.state.currentStep - 1)
        this.changeCalculating(false)
        this.$router.push({ name: this.pages[this.$store.state.currentStep].name })
      }
    },
    goToNextPage() {
      if (this.$store.state.currentStep < this.pages.length - 1) {
        this.changeCurrentStep(this.$store.state.currentStep + 1)
        this.changeCalculating(false)
        this.$router.push({ name: this.pages[this.$store.state.currentStep].name })
      }
    },
   
    goToStep(index) {
      // if (index == 0 || index == 1)
      this.changeCurrentStep(index)
      this.changeCalculating(false)
      this.$router.push({ name: this.pages[index].name })
    }
  },
  mounted() {
    const currentPath = window.location.pathname;
    const pathName = currentPath.includes('/quote/');
    if (pathName) {
      this.check_route = true;
    }
    console.log(this.$store.state.currentStep)
  },
  created() {

  },
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Overpass&display=swap');

* {
  outline: none !important;
}

.overlay {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  z-index: 99999;
  background-color: white;
}

.overscroll {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  z-index: 99999;
  background-color: white;
}

button {
  font-family: Overpass !important;
}

h1 {
  font-family: Overpass !important;
  font-style: normal;
  font-weight: 800;
  font-size: 32px;
  line-height: 42px;
}

h2 {
  font-family: Overpass !important;
  font-style: normal;
  font-weight: 800;
  font-size: 26px;
  line-height: 32px;
}

h3 {
  font-family: Overpass !important;
  font-style: normal;
  font-weight: 800;
  font-size: 22px;
  line-height: 30px;
}

p {
  font-family: Overpass !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 28px;
}

.inpt {
  background: #FFFFFF;
  border: 1px solid #6D818D;
  box-sizing: border-box;
  border-radius: 8px;
  left: 0px;
  top: 0px;
  border-radius: 8px;
  padding-left: 10px;
  height: 40px;

}

.inptError {
  background: #FFFFFF;
  border: 1px solid #E55026;
  box-sizing: border-box;
  border-radius: 8px;
  left: 0px;
  top: 0px;
  border-radius: 8px;
  padding-left: 10px;
  height: 40px;

}

.inpt:not(:placeholder-shown) {
  border: 1px solid #003878;
  font-family: Overpass;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: left;
  position: static;

  font-family: Overpass;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 183.84%;
}

.inpt:focus {
  background: #FFFFFF;
  /* primary */
  font-family: Overpass;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: left;
  position: static;

  font-family: Overpass;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 183.84%;
  /* identical to box height, or 29px */

  display: flex;
  align-items: center;

  /* black */

  color: #000000;


  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 2px;


  border: 1px solid #003878;
  box-sizing: border-box;
  /* button/focus */

  box-shadow: 0px 0px 0px 3px rgba(0, 56, 120, 0.2);
  border-radius: 8px;
}

.inpt::placeholder {
  position: absolute !important;
  width: 160px !important;
  height: 28px !important;
  left: 10px !important;
  top: calc(50% - 28px/2) !important;

  font-family: Overpass !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 16px !important;
  line-height: 28px !important;
  /* identical to box height, or 175% */

  display: flex !important;
  align-items: flex-end !important;

  /* grey/400 */

  color: #6D818D;
}



</style>